import { createSelector } from "reselect";

const getEntities = state => state.entities;
const getSelectedItem = state => state.selectedItem;

export const getPrevNextItem = createSelector(
  [getEntities, getSelectedItem],
  (entities, item) => {
    const { all, byId } = entities;

    let prevItem = null;
    let nextItem = null;

    if (item && item.id && all.length > 0) {
      const itemID = item.id;
      const index = all.indexOf(itemID);

      const prev = index - 1;
      prev > -1 ? (prevItem = byId[all[prev]]) : (prevItem = null);

      const next = index + 1;
      next < all.length ? (nextItem = byId[all[next]]) : (nextItem = null);
    }

    return {
      prevItem,
      nextItem
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/index.js